/**
 * Cache-bust query param for Shopify Data app proxy calls (/apps/shopifyData/*).
 * Bump SHOPIFY_DATA_APP_VERSION after backend/proxy migrations so browsers
 * treat endpoint URLs as new and skip stale HTTP caches.
 *
 * Load this script early (no defer) so it wraps fetch before other theme scripts run.
 */
(function (window) {
  'use strict';

  // Auto version by local date (YYYYMMDD-cm-app) so proxy URLs rotate daily and skip stale caches.
  var now = new Date();
  var yyyy = String(now.getFullYear());
  var mm = String(now.getMonth() + 1).padStart(2, '0');
  var dd = String(now.getDate()).padStart(2, '0');
  var SHOPIFY_DATA_APP_VERSION = yyyy + mm + dd + '-cm-app';
  var PROXY_MARKER = '/apps/shopifyData';

  function withShopifyDataVersion(url) {
    if (typeof url !== 'string' || url.indexOf(PROXY_MARKER) === -1) {
      return url;
    }
    if (/[?&]v=/.test(url)) {
      return url;
    }
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    return url + sep + 'v=' + encodeURIComponent(SHOPIFY_DATA_APP_VERSION);
  }

  window.SHOPIFY_DATA_APP_VERSION = SHOPIFY_DATA_APP_VERSION;
  window.withShopifyDataVersion = withShopifyDataVersion;

  var originalFetch = window.fetch;
  if (typeof originalFetch !== 'function') {
    return;
  }

  window.fetch = function (input, init) {
    try {
      if (typeof input === 'string') {
        input = withShopifyDataVersion(input);
      } else if (typeof URL !== 'undefined' && input instanceof URL) {
        var versionedHref = withShopifyDataVersion(input.href);
        if (versionedHref !== input.href) {
          input = new URL(versionedHref);
        }
      } else if (typeof Request !== 'undefined' && input instanceof Request) {
        var versionedRequestUrl = withShopifyDataVersion(input.url);
        if (versionedRequestUrl !== input.url) {
          input = new Request(versionedRequestUrl, input);
        }
      }
    } catch (e) {
      // Fall through to original fetch if URL rewriting fails.
    }

    return originalFetch.call(this, input, init);
  };
})(window);
